/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useUI } from "../theme/ThemeProvider";
import WhatsLayout from "../layouts/WhatsLayout";
import {
  DASHBOARD_PATH,
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTION_STATUS_EVENT,
  askToRenewExpiredPlan,
  isExpiredPlanAllowedPath,
  isSubscriptionMarkedExpired,
} from "../utils/expiredPlanAccess";

export default function ExpiredPlanRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang, theme } = useUI();
  const isArabic = lang === "ar";
  const isDark = theme === "dark";
  const [expired, setExpired] = useState(isSubscriptionMarkedExpired);
  const promptedRef = useRef(false);

  useEffect(() => {
    const sync = () => setExpired(isSubscriptionMarkedExpired());
    window.addEventListener(SUBSCRIPTION_STATUS_EVENT, sync);
    return () => window.removeEventListener(SUBSCRIPTION_STATUS_EVENT, sync);
  }, []);

  const allowed = !expired || isExpiredPlanAllowedPath(location.pathname);

  useEffect(() => {
    if (allowed) {
      if (promptedRef.current && Swal.isVisible()) Swal.close();
      promptedRef.current = false;
      return undefined;
    }

    let cancelled = false;
    promptedRef.current = true;
    askToRenewExpiredPlan({ isArabic, isDark }).then((renew) => {
      promptedRef.current = false;
      if (cancelled) return;
      navigate(renew ? SUBSCRIPTIONS_PATH : DASHBOARD_PATH, { replace: true });
    });

    return () => {
      cancelled = true;
    };
  }, [allowed, isArabic, isDark, location.pathname, navigate]);

  if (!allowed) {
    return <WhatsLayout title={null} />;
  }

  return <Outlet />;
}
